import { COMPLETED_BY, PLATFORM_TYPE } from '../constants/audienceTypes'

export const createEmptyAudience = (overrides = {}) => ({
  completedBy: COMPLETED_BY.subject,
  platformType: PLATFORM_TYPE.both,
  inheritedFromAnchor: { arm: false, phase: false },
  ...overrides,
})
